export default () => {}

document.addEventListener('turbo:before-render', () => {
  document.querySelectorAll('.flash').forEach((flash) => flash.remove())
})
